export default __webpack_public_path__ + "static/media/04__o_5.7ad05db2.jpg";